import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import useNewsFeed from '../hooks/useNewsFeed';

export default function NewsFeedModal({ open, onClose }) {
  const newsFeed = useNewsFeed();

  if (newsFeed.isLoading) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Message Board</DialogTitle>
      <DialogContent dividers>
        {!newsFeed.data.length && (
          <Typography variant="body2" color="textSecondary">
            No news messages yet.
          </Typography>
        )}
        {!!newsFeed.data.length && (
          <List dense>
            {newsFeed.data.map((m) => {
              const hasTitle = !!m.title;
              const dateStr = new Date(m.createdAt).toLocaleDateString();
              return (
                <>
                  <ListItem key={m.id} alignItems="flex-start">
                    <ListItemText
                      primary={dateStr}
                      primaryTypographyProps={{ style: { fontWeight: 700 } }}
                      secondary={
                        <>
                          {hasTitle && (
                            <Typography
                              variant="subtitle1"
                              style={{ fontWeight: 700, marginBottom: 4 }}
                            >
                              {m.title}
                            </Typography>
                          )}
                          {m.text}
                        </>
                      }
                    />
                  </ListItem>
                  <Divider component="li" />
                </>
              );
            })}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
